"use client";

import { useEffect } from "react";
import { useSession } from "@/lib/auth-client";
import posthog from "posthog-js";

/**
 * Component that integrates Better Auth authentication with PostHog
 * Identifies users in PostHog when they log in, enabling feature flags based on user properties
 */
export function AuthPostHogIntegration() {
  const { data: session, isPending } = useSession();

  useEffect(() => {
    // Wait for session to load
    if (isPending) {
      return;
    }

    // Ensure PostHog is initialized before using it
    if (typeof window === "undefined" || !posthog.config) {
      return;
    }

    // If user is authenticated, identify them in PostHog
    if (session?.user) {
      const user = session.user;

      // Identify the user in PostHog with their user ID
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        image: user.image,
        createdAt: user.createdAt,
        // Additional metadata that might be useful for feature flags
        hasEmail: !!user.email,
        hasImage: !!user.image,
        emailVerified: user.emailVerified,
      });

      // Capture a login event
      posthog.capture("user_logged_in", {
        userId: user.id,
        email: user.email,
        timestamp: new Date().toISOString(),
      });
    } else {
      // User is not authenticated, reset PostHog identity
      posthog.reset();
    }
  }, [session, isPending]);

  // This component doesn't render anything
  return null;
}
